import { downloadDataAsync, getDataAsync } from "../ZeosApiExecutor";
import {
  ICompliancePortfolioSummary,
  ICompliancePropertyStatus,
} from "../contracts/Compliance";

const BASE_URL = `/Compliance`;

export const Compliance = {
  getPortfolioSummary: async (companyId: number) => {
    return await getDataAsync<ICompliancePortfolioSummary>(
      `${BASE_URL}/Portfolio/${companyId}`,
      ""
    );
  },
  getPropertyCompliance: async (propertyId: number) => {
    return await getDataAsync<ICompliancePropertyStatus>(
      `${BASE_URL}/Property/${propertyId}`,
      ""
    );
  },
  downloadPortfolioReport: async (companyId: number, format: string) => {
    return await downloadDataAsync(
      `${BASE_URL}/Report/Portfolio/${companyId}?format=${format}`
    );
  },
  downloadPropertyReport: async (propertyId: number, format: string) => {
    return await downloadDataAsync(
      `${BASE_URL}/Report/Property/${propertyId}?format=${format}`
    );
  },
};
